import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const UserReply = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M8.8 13.6H15.2V13.16C15.2 12.5733 14.9067 12.1 14.32 11.74C13.7333 11.38 12.96 11.2 12 11.2C11.04 11.2 10.2667 11.38 9.68 11.74C9.09333 12.1 8.8 12.5733 8.8 13.16V13.6ZM12 10.4C12.44 10.4 12.8168 10.2432 13.1304 9.9296C13.4435 9.61653 13.6 9.24 13.6 8.8C13.6 8.36 13.4435 7.98347 13.1304 7.6704C12.8168 7.3568 12.44 7.2 12 7.2C11.56 7.2 11.1835 7.3568 10.8704 7.6704C10.5568 7.98347 10.4 8.36 10.4 8.8C10.4 9.24 10.5568 9.61653 10.8704 9.9296C11.1835 10.2432 11.56 10.4 12 10.4ZM4 20V5.6C4 5.16 4.1568 4.7832 4.4704 4.4696C4.78347 4.15653 5.16 4 5.6 4H18.4C18.84 4 19.2168 4.15653 19.5304 4.4696C19.8435 4.7832 20 5.16 20 5.6V15.2C20 15.64 19.8435 16.0168 19.5304 16.3304C19.2168 16.6435 18.84 16.8 18.4 16.8H7.2L4 20Z" />
  </SvgIcon>
));

UserReply.displayName = 'UserReply';

export default UserReply;
